import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import duration from 'dayjs/plugin/duration';
import customParseFormatter from 'dayjs/plugin/customParseFormat';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.extend(customParseFormatter);

export default dayjs;

export const keepUTCTime = (date?: any) => {
  return dayjs.utc(date);
};

export const PERU_TZ = 'America/Lima';

export const convertToLimaTZ = (date?: any) => {
  return dayjs(date).tz(PERU_TZ);
};

// NOTE: coverts date to lima tz whereas  convertToLimaTZ converts to utc and them to lima. causing day unshift back
// check and replace convertToLimaTZ with directLimaConvert
export const directLimaConvert = (date?: any) => {
  return dayjs.tz(date, PERU_TZ);
};

export const setToDayEnd = (date?: any) => {
  return convertToLimaTZ(date).endOf('day');
};

export const setDirectToDayEnd = (date?: any) => {
  return directLimaConvert(date).endOf('day');
};

export const setToDayStart = (date?: any) => {
  return convertToLimaTZ(date).startOf('day');
};

export const formatDateToDDMMYYYY = (dateString?: string): string => {
  if (!dateString) {
    return '';
  }

  let parsedDate;

  if (dateString.includes('-')) {
    parsedDate = dayjs.utc(dateString, 'YYYY-MM-DD', true);
  } else if (dateString.includes('/')) {
    parsedDate = dayjs.utc(dateString, 'DD/MM/YYYY', true);
  } else {
    parsedDate = dayjs.utc(dateString, 'YYYY-MM-DD', true);
    if (!parsedDate.isValid()) {
      parsedDate = dayjs.utc(dateString, 'DD/MM/YYYY', true);
    }
  }

  if (!parsedDate.isValid()) {
    console.warn(`Invalid date format: ${dateString}`);
    return '';
  }

  return parsedDate.format('DD/MM/YYYY');
};
